import React, { useEffect, useRef, useState } from 'react';

const DraggableModal = ({
  isVisible,
  onClose,
  title,
  initialLeft = 24,
  initialTop = 24,
  width = 520,
  height = 0,
  style = { border: "1px solid green" },
  children,
}) => {
  const modalRef = useRef(null);
  const [position, setPosition] = useState({ left: initialLeft, top: initialTop });
  const [dragging, setDragging] = useState(false);
  const dragOffsetRef = useRef({ x: 0, y: 0 });

  useEffect(() => {
    setPosition({ left: initialLeft, top: initialTop });
  }, [initialLeft, initialTop, isVisible]);

  useEffect(() => {
    if (!dragging) return;
    const handleMouseMove = (e) => {
      const newLeft = e.clientX - dragOffsetRef.current.x;
      const newTop = e.clientY - dragOffsetRef.current.y;

      const maxLeft = window.innerWidth - (width || (modalRef.current?.offsetWidth || 0)) - 8;
      const maxTop = window.innerHeight - (modalRef.current?.offsetHeight || 0) - 8;

      setPosition({
        left: Math.max(8, Math.min(newLeft, maxLeft)),
        top: Math.max(8, Math.min(newTop, maxTop)),
      });
    };
    const handleMouseUp = () => setDragging(false);
    window.addEventListener('mousemove', handleMouseMove);
    window.addEventListener('mouseup', handleMouseUp);
    return () => {
      window.removeEventListener('mousemove', handleMouseMove);
      window.removeEventListener('mouseup', handleMouseUp);
    };
  }, [dragging, width]);

  const onMouseDownHeader = (e) => {
    if (!modalRef.current) return;
    const rect = modalRef.current.getBoundingClientRect();
    dragOffsetRef.current = { x: e.clientX - rect.left, y: e.clientY - rect.top };
    setDragging(true);
  };

  if (!isVisible) return null;

  return (
    <div
      ref={modalRef}
      className="fixed bg-white shadow-2xl rounded-lg z-[60]"
      style={{
        left: position.left,
        top: position.top,
        width: typeof width === 'number' ? `${width}px` : width,
        maxHeight: height ? `${height}px` : '80vh',
        ...style,
      }}
    >
      <div
        className="cursor-move flex items-center justify-between px-4 py-2 border-b bg-gray-50 rounded-t-lg"
        onMouseDown={onMouseDownHeader}
      >
        <div className="font-bold text-gray-800 text-2xl text-center">{title}</div>
        <button
          type="button"
          className="text-gray-500 hover:text-gray-800 h-7 w-7 inline-flex items-center justify-center"
          onClick={onClose}
          aria-label="Close"
        >
          <svg className="w-4 h-4" aria-hidden="true" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M1 1l12 12M13 1L1 13" stroke="currentColor" strokeWidth="2" strokeLinecap="round" />
          </svg>
        </button>
      </div>
      <div className="overflow-auto" style={{ maxHeight: height ? `${height - 40}px` : 'calc(80vh - 40px)' }}>
        {children}
      </div>
    </div>
  );
};

export default DraggableModal;


